RivalIQ.apps.AccountSettings.module('models', function (models, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    models.presentInvoiceDates = function (invoices) {
        return invoices.map(function (invoice) {
            return {
                value: invoice.id,
                display: moment.unix(invoice.date).format('LL LTS') + (!invoice.paid ? ' (unpaid)' : '')
            };
        });
    };

}, window.moment);
